"use strict";
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".ms-GroupSpacer{display:inline-block}" }]);
/* tslint:enable */ 

//# sourceMappingURL=GroupSpacer.scss.js.map



//////////////////
// WEBPACK FOOTER
// ../components/GroupedList/GroupSpacer.scss.js
// module id = 128
// module chunks = 0